// Theme colors
export const COLORS = {
  primary: '#003366', // Dark blue (main color)
  secondary: '#FF9900', // Orange (accent color)
  light: '#FFFFFF',
  dark: '#1A202C',
  gray: {
    100: '#F7FAFC',
    200: '#EDF2F7',
    300: '#E2E8F0',
    400: '#CBD5E0',
    500: '#A0AEC0',
    600: '#718096',
    700: '#4A5568',
    800: '#2D3748',
    900: '#1A202C',
  },
};

// Navigation links (for Header)
export const NAV_LINKS = [
  { id: 'home', label: 'Главная', to: 'hero', style: { userSelect: 'none', cursor: 'default' } },
  { id: 'about', label: 'О нас', to: 'about', style: { userSelect: 'none', cursor: 'default' } },
  { id: 'services', label: 'Услуги', to: 'services', style: { userSelect: 'none', cursor: 'default' } },
  { id: 'cases', label: 'Кейсы', to: 'cases', style: { userSelect: 'none', cursor: 'default' } },
  { id: 'advantages', label: 'Преимущества', to: 'advantages', style: { userSelect: 'none', cursor: 'default' } },
  { id: 'contacts', label: 'Контакты', to: 'contacts', style: { userSelect: 'none', cursor: 'default' } },
];

// Company info
export const COMPANY_INFO = {
  name: 'IT Joy',
  foundedYear: 2005,
  phone: '+7 914 545 7168',
  email: 'mail@itjoy.space',
  address: 'г. Хабаровск, ул. Пионерская 1',
  workingHours: 'Пн-Пт: 9:00 - 18:00',
  socialLinks: [
   // { name: 'LinkedIn', url: 'https://linkedin.com/' },
   // { name: 'Facebook', url: 'https://facebook.com/' },
    { name: 'Telegram', url: 'https://t.me/Saler_ITJOY_bot' },
  ],
};

// Services data with proper icon type
export const SERVICES_DATA = [
  {
    id: 'network',
    icon: 'network' as const,
    title: 'Сетевая инфраструктура',
    description:
      'Строим надежные и быстрые сети (оптика, Wi-Fi мосты), чтобы ваши сотрудники работали эффективно, а данные передавались безопасно.',
  },
  {
    id: 'video',
    icon: 'cctv' as const,
    title: 'Системы видеонаблюдения',
    description:
      'Организуем видеонаблюдение "под ключ" (PoE, Wi-Fi) с удобным доступом к архиву и мониторингом работоспособности.',
  },
  {
    id: 'voip',
    icon: 'phone' as const,
    title: 'IP-Телефония (VoIP/SIP)',
    description:
      'Настроим современную телефонию для экономии на связи и интеграции с CRM. Не теряйте ни одного звонка!',
  },
  {
    id: 'support',
    icon: 'support' as const,
    title: 'IT-Сопровождение и Аутсорсинг',
    description:
      'Возьмем на себя заботу о вашей IT-инфраструктуре: поддержка пользователей, резервное копирование, мониторинг. Работайте спокойно!',
  },
  {
    id: 'automation',
    icon: 'automation' as const,
    title: 'Автоматизация и Интеграции',
    description:
      'Внедряем умные системы (доступ, учет) и интегрируем их с 1С/ERP для оптимизации ваших бизнес-процессов.',
  },
  {
    id: 'monitoring',
    icon: 'monitoring' as const,
    title: 'Система Мониторинга IT Joy',
    description:
      'Подключим ваше оборудование к нашей системе: вы первыми узнаете о сбоях (часто раньше вас!), минимизируем простои и потери.',
    highlight: true,
  },
];

// Case studies data
export const CASE_STUDIES = [
  {
    id: 'case1',
    client: 'Завод металлоконструкций',
    size: '50 000 м², 7 лет сотрудничества',
    challenge:
      'Устаревшая сеть, высокие расходы на связь, нужен контроль территории при ограниченном бюджете.',
    solution:
      'Проложили 5 км оптики, установили 60 камер с локальными регистраторами, добились скидки 25% от провайдера, предложили продавать интернет арендателям.',
    result: [
      'Окупаемость за 12 месяцев',
      'Экономия на связи 40%',
      'Снижение числа инцидентов на 30%',
    ],
    image: 'factory',
  },
  {
    id: 'case2',
    client: 'Офис + склад',
    size: 'Офис + склад, 5 зданий, 10 лет сотрудничества',
    challenge:
      'Компания находилась на этапе строительства, не было IT-инфраструктуры, некачественный подряд на сайт, высокие затраты на интернет и связь, отсутствовала централизованная система безопасности и телефонии.',
    solution:
      'С нуля спроектировали и внедрили IT-инфраструктуру. Настроили видеонаблюдение, установили сервера для 1С и систему резервного копирования. Подключили и настроили SIP-телефонию. Провели переговоры с провайдерами и добились оптимальных условий. Доработали шаблон сайта после неудачного проекта с подрядчиком. Помогли интегрировать медицинское оборудование в сеть.',
    result: [
      'Снижение IT-расходов на 30% за счёт переговоров с провайдерами',
      'Надёжная система резервного копирования и работы серверов 1С',
      'Полноценное сопровождение компании более 10 лет',
      'Помощь в реализации сложных интеграций с медицинским оборудованием',
    ],
    image: 'medical-office',
  },

  {
    id: 'case3',
    client: 'Бюро ритуальных услуг',
    size: '5 филиалов по городу, удалённые объекты',
    challenge:
      'Облачное видеонаблюдение с высокой абонентской платой и ограниченным архивом. Камеры работали только через платный облачный сервис, локальный доступ был невозможен. Требовалось масштабируемое решение для сети филиалов.',
    solution:
      'Перепрошили камеры, подключили локальный регистратор, увеличили глубину архива до 60 дней. Без увеличения бюджета расширили систему наблюдения. Настроили удалённый доступ и централизованный мониторинг. Обеспечили стабильную работу системы на всех объектах без зависимости от облака.',
    result: [
      'Окупаемость проекта менее чем за 12 месяцев',
      'Увеличение глубины архива с 7 до 90 дней',
      'Снижение ежемесячных затрат на видеонаблюдение до нуля',
      'Централизованное управление видеонаблюдением во всех филиалах',
      'Бесперебойное обслуживание более 10 лет',
    ],
    image: 'funeral-service',
  },
  {
  id: 'case4',
  client: 'Товарищество собственников жилья (ТСЖ)',
  size: 'Многоквартирный жилой комплекс, 3 поста охраны, подземная парковка',
  challenge:
    'Необходимость организовать видеонаблюдение на придомовой территории. Отсутствие интернета и связи в постах охраны. Высокие ежемесячные затраты на охрану, нестабильная сотовая связь в паркинге.',
  solution:
    'Установили более 20 IP-камер с использованием коммутаторов для гибкой прокладки трасс. Протянули интернет и телефонию до всех постов охраны. Предложили автоматизировать открытие ворот с помощью системы распознавания номеров, отказавшись от постоянного присутствия охраны — это позволило экономить более 50 000 ₽ ежемесячно. Установили усилитель сотовой связи в паркинге и обеспечили возможность управления прогрева автотранспорта через SMS. Постепенно расширили систему до 60+ камер, включая лифты, паркинг и офисные помещения. Обеспечили стабильную работу через источники бесперебойного питания и подключение видеонаблюдениялифтов по Wi-Fi мостам.',
  result: [
    'Снижение ежемесячных затрат на охрану на 50 000 ₽',
    'Глубокая модернизация всей IT-инфраструктуры дома',
    'Надёжное видеонаблюдение с более чем 60 камерами и 4 регистраторами',
    'Централизованная система хранения, резервное питание, стабильная маршрутизация',
    'Круглосуточная техподдержка',
    'Объект обслуживается с 2018 года',
  ],
  image: 'residential-building',
},
  
];

// Advantages data with proper icon types
export const ADVANTAGES = [
  {
    id: 'comprehensive',
    icon: 'allinone' as const,
    title: 'Комплексный подход',
    description: 'Все IT-задачи в одном окне: от аудита до поддержки 24/7.',
  },
  {
    id: 'honesty',
    icon: 'transparency' as const,
    title: 'Честность и Прозрачность',
    description: 'Понятные цены без скрытых платежей. Работаем по договору.',
  },
  {
    id: 'flexibility',
    icon: 'flexibility' as const,
    title: 'Гибкость и Адаптивность',
    description: 'Решения точно под ваш бюджет и цели. Не навязываем лишнего.',
  },
  {
    id: 'experience',
    icon: 'experience' as const,
    title: 'Опыт и Надежность',
    description: '19+ лет на рынке (с 2005 г.), сотни успешных проектов. Мы знаем, что делаем.',
  },
  {
    id: 'proactive',
    icon: 'proactive' as const,
    title: 'Проактивный Мониторинг',
    description: 'Предотвращаем проблемы до их появления с нашей системой контроля.',
  },
  {
    id: 'quality',
    icon: 'quality' as const,
    title: 'Гарантия Качества',
    description: 'Отвечаем за результат и предоставляем гарантию на работы.',
  },
];

// Client testimonials
export const TESTIMONIALS = [
  {
    id: 'testimonial1',
    text: 'Команда IT Joy помогла навести порядок в нашей технике: настроили компьютеры, подключили принтеры, установили выделенный сервер для 1С. Когда сломался жёсткий диск, они спасли десяток баз — для нас это было критично. Также организовали надёжное резервное копирование, чтобы подобное не повторилось. Особенно ценим, что всё объясняют простым и понятным языком.',
    author: 'Ирина Петровна',
    position: 'Директор, ООО "Ваш Бухгалтер"',
    image: '/src/assets/images/avatars/avatar1.jpg',
  },
  
  {
    id: 'testimonial2',
    text: 'Познакомились с IT Joy на этапе строительства нового офисного здания — их порекомендовал прораб. С тех пор они проложили сети уже в четырёх наших объектах. Работают на доверии, спокойно относятся к изменениям в процессе, всегда готовы переделать и найти лучшее решение. Предлагают несколько вариантов, подробно объясняют каждый, чтобы было понятно. Сотрудничаем уже больше 10 лет — и продолжаем.',
    author: 'Наливайченко Игорь Иванович',
    position: 'Директор, ООО "Строймедсервис"',
    image: '/src/assets/images/avatars/avatar2.jpg',
  },
  
  {
    id: 'testimonial3',
    text: 'О IT Joy нам рассказали арендаторы. Нужно было восстановить видеонаблюдение на территории завода — старая система вышла из строя. Ребята подошли к делу поэтапно: шаг за шагом усилили контроль, и мы сразу заметили, что случаев воровства стало меньше. Позже они предложили подключать арендаторов к нашему интернету за доплату — отличное решение! Организовали сеть по всей территории и договорились с провайдером. Работают с умом и на результат.',
    author: 'Туптина Виктория',
    position: 'Директор, ООО "ДЗМК №1"',
    image: '/src/assets/images/avatars/avatar3.png',
  },
];

// Partner logos
// export const PARTNER_LOGOS = [
//   { id: 'partner1', name: 'Строймедсервис', image: 'logo1' },
//   { id: 'partner2', name: 'ДЗМК1', image: 'logo2' },
//   { id: 'partner3', name: 'ТоргСеть', image: 'logo3' },
//   { id: 'partner4', name: 'Логистическая компания "Доставка"', image: 'logo4' },
//   { id: 'partner5', name: 'Производство "ПромТех"', image: 'logo5' },
// ];
